import { useState } from 'react';
import { Dropdown } from 'components/helpers/Dropdown';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

import './AssestmentLanguageSelector.scss';

export type LanguageOption = {
    value: string;
    label: string;
}
export type LanguageOptions = LanguageOption[]

type AssessmentLanguageSelectorProps = {
    languageOptions: LanguageOptions;
    selectedLanguageControlled?: LanguageOption;
    onSelectLanguage?: (language: LanguageOption) => void;
    disabled?: boolean;
};

const AssessmentLanguageSelector = ({ onSelectLanguage, languageOptions, selectedLanguageControlled, disabled }: AssessmentLanguageSelectorProps) => {
    const [selectedLanguage, setSelectedLanguage] = useState<LanguageOption | undefined>(selectedLanguageControlled);
    const { t } = useTranslation('Assessment+Language+Selector', { i18n });

    const handleLanguageChange = (value: LanguageOption) => {
        setSelectedLanguage(value);

        onSelectLanguage?.(value);
    };

    return (
        <Dropdown
            placeholder={t('SSCandidate_Assessment_Language_Selector_Placeholder_Select')}
            options={languageOptions}
            // value={selectedLanguageControlled || selectedLanguage}
            value={selectedLanguage}
            onChange={handleLanguageChange}
            showTooltip
            readOnly={disabled}
            tooltipText={t('SSCandidate_Assessment_Language_Selector_Tooltip')}
            dropdownProps={{
                id: 'assessment-language-selector',
                isSearchable: false,
            }}
        />
    );
};

export default AssessmentLanguageSelector;